export default {
	//사용자 관리
	user: {}, //로그인한 사용자 정보
	langCd: 'ko_KR', //기본 언어: 한국어
	topSkin: process.env.VUE_APP_THEME_DEFAULT, //색상 테마
	font: 'HyundaiSans', //폰트 테마
	//plantCd: '', //공장 코드

	//다국어 관리
	userMessageList: [], //조회한 다국어 원본 리스트
	userMessage: new Map(), //조회한 다국어 리스트를 Map으로 저장

	//세션 관리
	sessionState: false, //세션 관리 여부 상태
	sessionTimeout: null, //세션 Timeout 시간
	sessionCounter: null, //세션 초기화까지 남은 시간, 기본 값: 86400(24시간)
	screenTimeout: null, //스크린 Timeout 시간
	screenCounter: null, //사용자 움직임 감시 남은 시간, 기본 값: 1800(30분)
	sessionAlarmTime: null, //세션 강조 기준 시간
	sessionId: '', //Backend에서 보내주는 sessionId base64 암호화
	isLogout: false, //로그인 상태 여부, 사용자 비밀번호 재설정에서 사용

	screenArray: new Map(),
	//메뉴 관리
	menuList: [], //조회한 메뉴 원본 리스트
	menuMap: new Map(), //조회한 메뉴를 Map으로 저장
	homeUrl: '', //로그인 후 이동할 첫 화면 url
	homeContentUrl: '', //첫페이지 Home화면에서 iframe으로 보여줄 화면 url (위젯)
	homeScrId: '', //첫페이지 Home화면에서 iframe으로 보여줄 화면 아이디 (위젯)
	screenObj:null,
	favorites: [] //즐겨찾기 화면 정보 리스트

	
};
